import { render, staticRenderFns } from "./VTaskSubscribe.vue?vue&type=template&id=2a6456b4&scoped=true"
import script from "./VTaskSubscribe.vue?vue&type=script&lang=ts"
export * from "./VTaskSubscribe.vue?vue&type=script&lang=ts"
import style0 from "./VTaskSubscribe.vue?vue&type=style&index=0&id=2a6456b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6456b4",
  null
  
)

export default component.exports